<app-bread-crumb [items]="[{text:  'utilizadores',link:'/admin/users'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe do Utilizador'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-4">
      <!-- Profile Image -->
      <div class="box box-success" style="border-top: 2px solid #f35309;">

        <div class="box-body box-profile">

          <img 
            class="img-responsive" 
            style="width:150px ;height:150px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;" 
            [src]="user.picture || 'http://localhost:4200/assets/Khuzela.png'"
            alt="imagem do parceiro">

          <h3 class="profile-username text-center">{{user?.name}}</h3>

          <p class="text-muted text-center">{{user?.email}}</p>

          <ul class="list-group list-group-unbordered">
            <li class="list-group-item">
              <div class="upload-btn-wrapper">

                <button class="btn btn-outline-danger btn-block">
                  <i class="fa fa-cloud-upload"></i> Clique aqui para actualizar o logotipo
                </button>
    
                <input title="" type="file" #iptFile (input)="updateImageProfile($event,user)"/>
                <!-- <small class="text-primary">{{ iptFile?.files[0]?.name }}</small> -->
              </div>
            </li>
          </ul>

        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </div>


    <div class="col-md-8">

      <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

        <div class="box-footer no-padding">
          <ul class="nav nav-stacked">
            <li><a href="javascript:void(0);"><strong>Nuit</strong> <span class="pull-right">{{user?.nuit}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Email</strong> <span class="pull-right">{{user?.email}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Telefone</strong> <span class="pull-right">{{user?.phone}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Endereço</strong> <span class="pull-right">{{user?.address}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Clube</strong> <span class="pull-right">{{user?.club?.name || 'Utilizador Khuzela'}}</span></a></li>
            <li class="botao">
              <button type="button" (click)="editUser(user)" class="btn btn-outline-danger pull-right"><strong><i
                    class="fa fa-edit"></i> Editar</strong></button>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>

</section>